export function NewIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M2 5a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1zM3 18a1 1 0 100 2h18a1 1 0 100-2H3zM3.832 8.445A1 1 0 002 9v6a1 1 0 102 0v-2.697l2.168 3.252A1 1 0 008 15V9a1 1 0 10-2 0v2.697L3.832 8.445zM10 8a1 1 0 00-1 1v6a1 1 0 001 1h3a1 1 0 100-2h-2v-1h2a1 1 0 100-2h-2v-1h2a1 1 0 100-2h-3zM17 9a1 1 0 10-2 0v6a1 1 0 001.371.928l2.129-.851 2.129.851A1 1 0 0022 15V9a1 1 0 10-2 0v4.523l-.5-.2V12a1 1 0 10-2 0v1.323l-.5.2V9z"
      ></path>
    </svg>
  );
}
